import type { PresetConfig, MaterialPreset } from "./types.ts";

export const PRESETS: Record<MaterialPreset, PresetConfig> = {
  wood: {
    label_pl: "Drewno / Płyty",
    label_en: "Wood / Panels",
    icon: "🪵",
    default_kerf: 3.0,
    allow_rotation: false, // grain direction matters
    default_stocks: [
      { width: 2800, height: 2070, label: "Standard 2800×2070", cost: 0 },
      { width: 2440, height: 1220, label: "Standard 2440×1220", cost: 0 },
    ],
    unit: "mm",
  },
  glass: {
    label_pl: "Szkło",
    label_en: "Glass",
    icon: "🪟",
    default_kerf: 2.0,
    allow_rotation: true,
    default_stocks: [
      { width: 3210, height: 2250, label: "Jumbo 3210×2250", cost: 0 },
      { width: 2550, height: 1605, label: "Standard 2550×1605", cost: 0 },
    ],
    unit: "mm",
  },
  metal: {
    label_pl: "Blacha",
    label_en: "Sheet Metal",
    icon: "⚙️",
    default_kerf: 1.5,
    allow_rotation: true,
    default_stocks: [
      { width: 2500, height: 1250, label: "Standard 2500×1250", cost: 0 },
      { width: 3000, height: 1500, label: "Duży 3000×1500", cost: 0 },
    ],
    unit: "mm",
  },
  stone: {
    label_pl: "Kamień",
    label_en: "Stone / Granite",
    icon: "🪨",
    default_kerf: 4.0,
    allow_rotation: true,
    default_stocks: [
      { width: 3200, height: 1600, label: "Slab 3200×1600", cost: 0 },
    ],
    unit: "mm",
  },
};
